import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

// One line of a details panel: the label on the left, the value on the right; a long
// value wraps instead of overflowing the card.
const InfoRow = ({ label, children }: { label: ReactNode; children: ReactNode }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    gap={2}
    py={1.25}
    sx={{ "&:not(:last-of-type)": { borderBottom: 1, borderColor: "divider" } }}
  >
    <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
      {label}
    </Typography>
    <Box
      sx={{
        minWidth: 0,
        textAlign: "right",
        fontWeight: 700,
        fontSize: 14,
        overflowWrap: "anywhere",
        // An empty react-admin field renders an empty span: show a dash instead of a blank.
        "& .MuiTypography-root:empty::after": { content: '"—"', color: "text.disabled", fontWeight: 400 },
      }}
    >
      {children}
    </Box>
  </Box>
);

export default InfoRow;
